import { graphQueryBang, graphQuery } from "shared/lib/graphql"
import { SubscriptionUpdateMutation, TierPricesQuery } from "./queries"

type updateSubscriptionPlanProps = {
  productId: string
}

export const updateSubscriptionPlan = async ({
  productId,
}: updateSubscriptionPlanProps) => {
  const graphConfigs = { awaitClearCache: true }
  const response = await graphQueryBang(
    SubscriptionUpdateMutation,
    {
      product_id: productId,
    },
    graphConfigs
  )
  return response.userSubscriptionUpdate
}

export const loadTierPrices = async () => {
  const response = await graphQuery(TierPricesQuery)
  return response.data.tier_prices.pro
}

export const loadSubscriptionInterval = async (url: string) => {
  return fetch(url, {
    headers: { "Content-Type": "application/json" },
  }).then(response => response.json())
}
